import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLanguage } from "../context/LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Testimonials = () => {
  const { t, lang } = useLanguage();
  const [items, setItems] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/testimonials`)
      .then((res) => {
        if (mounted) setItems(res.data || []);
      })
      .catch(() => {
        if (mounted) setItems([]);
      });
    return () => {
      mounted = false;
    };
  }, []);

  const next = () => setIndex((i) => (items.length ? (i + 1) % items.length : 0));
  const prev = () => setIndex((i) => (items.length ? (i - 1 + items.length) % items.length : 0));

  if (items.length === 0) return null;

  const current = items[index];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="section-padding bg-white relative overflow-hidden"
    >
      <div className="pointer-events-none absolute inset-0 diagonal-stripes" aria-hidden="true"></div>
      <div className="container-page relative">
        <div className="max-w-3xl">
          <span className="chip mb-5">{t.testimonials.eyebrow}</span>
          <h2
            data-testid="testimonials-title"
            className="font-display font-black text-4xl sm:text-5xl text-navy leading-[1.05]"
          >
            {t.testimonials.title}
          </h2>
          <p className="mt-5 text-base md:text-lg text-foreground/75 leading-relaxed">
            {t.testimonials.lead}
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-8">
            <blockquote
              key={current.id}
              data-testid="testimonial-current"
              className="relative rounded-2xl bg-[#0A192F] p-10 md:p-12 text-white shadow-2xl animate-fade-in"
            >
              <i className="fa-solid fa-quote-left text-[#FF5A1F] text-4xl" aria-hidden="true"></i>
              <p className="mt-5 font-display text-xl md:text-2xl lg:text-3xl leading-snug text-white/95">
                « {lang === "fr" ? current.quote_fr : current.quote_en} »
              </p>
              <footer className="mt-8 flex items-center justify-between gap-4 pt-6 border-t border-white/10">
                <div>
                  <p className="font-display font-bold text-white text-base">
                    {current.name}
                  </p>
                  <p className="text-xs text-white/60 mt-0.5">{current.context}</p>
                </div>
                <div className="flex items-center gap-1 text-[#FF5A1F]">
                  {Array.from({ length: current.rating }).map((_, i) => (
                    <i key={i} className="fa-solid fa-star text-sm" aria-hidden="true"></i>
                  ))}
                </div>
              </footer>
            </blockquote>

            <div className="mt-6 flex items-center justify-between">
              <div className="flex items-center gap-1.5">
                {items.map((_, i) => (
                  <button
                    key={i}
                    type="button"
                    data-testid={`testimonial-dot-${i}`}
                    onClick={() => setIndex(i)}
                    className={`h-2 rounded-full transition-all ${
                      i === index ? "w-8 bg-[#FF5A1F]" : "w-2 bg-border hover:bg-muted-foreground/40"
                    }`}
                    aria-label={`Témoignage ${i + 1}`}
                  />
                ))}
              </div>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  data-testid="testimonial-prev"
                  onClick={prev}
                  className="h-11 w-11 rounded-full border border-border bg-white text-navy hover:bg-[#0A192F] hover:text-white hover:border-[#0A192F] transition"
                  aria-label="Précédent"
                >
                  <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
                </button>
                <button
                  type="button"
                  data-testid="testimonial-next"
                  onClick={next}
                  className="h-11 w-11 rounded-full border border-border bg-white text-navy hover:bg-[#0A192F] hover:text-white hover:border-[#0A192F] transition"
                  aria-label="Suivant"
                >
                  <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>

          {/* List of other testimonials */}
          <div className="lg:col-span-4 space-y-3">
            {items.map((it, i) => (
              <button
                key={it.id}
                type="button"
                onClick={() => setIndex(i)}
                data-testid={`testimonial-item-${i}`}
                className={`w-full text-left rounded-xl border p-4 transition ${
                  i === index
                    ? "border-[#FF5A1F] bg-[#FF5A1F]/5"
                    : "border-border bg-white hover:border-muted-foreground/40"
                }`}
              >
                <div className="flex items-center justify-between">
                  <p className="font-display font-bold text-navy text-sm">{it.name}</p>
                  <div className="flex items-center gap-0.5 text-[#FF5A1F] text-[11px]">
                    {Array.from({ length: it.rating }).map((_, k) => (
                      <i key={k} className="fa-solid fa-star" aria-hidden="true"></i>
                    ))}
                  </div>
                </div>
                <p className="text-xs text-muted-foreground mt-0.5">{it.context}</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
